/* H26 · Hero — slide fora da tela fica `inert` (sem foco/leitor de tela nos CTAs escondidos);
   slide claro na tela põe .is-light no hero (dots escuros).
   Troca automática (data-h26-autoplay = ms): avança 1 slide e volta ao 1º no fim. Pausa com mouse em cima
   ou foco dentro, hero fora da tela e aba escondida; com "reduzir movimento" não liga. Toque, arraste,
   roda, setas e dots zeram a contagem (a pessoa ganha os 5s inteiros no slide que escolheu).
   Setas, dots e estado ativo são do carrossel da base (h26.js). */
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-h26-hero]').forEach(function (root) {
      if (root.__h26hs) return; root.__h26hs = true;
      var track = root.querySelector('[data-h26-track]');
      if (!track || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.inert = e.intersectionRatio < 0.5;
          // slide claro na tela: dots escuros (o ativo branco some no fundo off-white)
          if (e.intersectionRatio >= 0.5) root.classList.toggle('is-light', e.target.classList.contains('h26-hero__slide--light'));
        });
      }, { root: track, threshold: [0, 0.5, 1] });
      Array.prototype.forEach.call(track.children, function (s) { io.observe(s); });
      autoplay(root, track);
      fitArt(root);
    });
  }
  /* slide de arte no mobile: a arte (no topo) não pode descer até o bloco de texto (ancorado embaixo).
     Mede o espaço livre e entrega pro CSS em --h26-art-h; o CSS só usa ≤749. */
  function fitArt(root) {
    var slides = root.querySelectorAll('.h26-hero__slide--art');
    if (!slides.length || !('ResizeObserver' in window)) return;
    slides.forEach(function (s) {
      var img = s.querySelector('.h26-hero__media--art img'), content = s.querySelector('.h26-hero__content');
      if (!img || !content) return;
      function fit() {
        var free = content.getBoundingClientRect().top - s.getBoundingClientRect().top - 16;
        if (free > 0) img.style.setProperty('--h26-art-h', Math.floor(free) + 'px');
      }
      new ResizeObserver(fit).observe(s);
      new ResizeObserver(fit).observe(content);
      fit();
    });
  }
  function autoplay(root, track) {
    var ms = parseInt(root.getAttribute('data-h26-autoplay'), 10);
    if (!ms || track.children.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var timer = null, hover = false, focus = false, onScreen = true;
    function next() {
      var w = track.clientWidth; if (!w) return;
      var i = Math.round(track.scrollLeft / w), n = track.children.length;
      var to = track.children[(i + 1) % n];
      track.scrollTo({ left: to.offsetLeft - track.children[0].offsetLeft, behavior: 'smooth' });
    }
    function stop() { clearInterval(timer); timer = null; }
    function sync() { stop(); if (!hover && !focus && onScreen && !document.hidden) timer = setInterval(next, ms); }
    // hover só de mouse: no touch o toque dispara mouseenter e nunca o leave (pausaria pra sempre)
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; sync(); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; sync(); } });
    // foco só pausa se veio do teclado/leitor (clique em seta também foca e não deve travar a rotação)
    root.addEventListener('focusin', function (e) { focus = e.target.matches(':focus-visible'); sync(); });
    root.addEventListener('focusout', function () { focus = false; sync(); });
    ['pointerdown', 'wheel', 'keydown'].forEach(function (ev) { root.addEventListener(ev, sync, { passive: true }); });
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
